import { render, staticRenderFns } from "./NuovaTerapia.vue?vue&type=template&id=4f3d9094&"
import script from "./NuovaTerapia.vue?vue&type=script&lang=js&"
export * from "./NuovaTerapia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports